import _defineProperty from "/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { getParameters } from "codesandbox-import-utils/lib/api/define";
import * as React from "react";
import { useSandpack } from "./useSandpack";

var getFileParameters = function getFileParameters(files, environment) {
  var normalized = Object.keys(files).reduce(function (prev, next) {
    return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, next.replace("/", ""), {
      content: files[next].code,
      isBinary: false
    }));
  }, {});
  return getParameters(_objectSpread({
    files: normalized
  }, environment ? {
    template: environment
  } : null));
};

export var useCodeSandboxLink = function useCodeSandboxLink() {
  var _useSandpack = useSandpack(),
      sandpack = _useSandpack.sandpack;

  var params = getFileParameters(sandpack.files, sandpack.environment); // Register the usage of the codesandbox link

  React.useEffect(function () {
    sandpack.openInCSBRegisteredRef.current = true;
  }, []);
  return "https://codesandbox.io/api/v1/sandboxes/define?parameters=".concat(params, "&query=file=").concat(sandpack.activePath, "%26from-sandpack=true");
};